import config from './config'
// const baseUrl = 'http://scenic.test.tuliyou.com/'
const baseUrl = config.baseURL
const basePath = config.basePath
const v5 = config.v5
const scenicBasePath = config.scenicBasePath

export default {
    // 微信jssdk注册
    registerSDK: `${baseUrl + basePath}wechat/register`,
    // 获取当前景区的分类
    // allClassify: `${baseUrl + basePath}scenic/classify_all`,
    // 获取当前景区的全景图信息
    panoramaInfo: `${baseUrl + basePath}scenic/panorama`,
    // 获取当前景区的某分类下的景点数据
    // spots: `${baseUrl + basePath}scenic/viewpoint_all`,
    // 搜索
    searchScenicSpots: `${baseUrl + basePath}scenic/search`,
    // 景区信息
    scenicInfo: `${baseUrl + basePath}scenic/detail`,
    // 线路规划
    scenicLines: `${baseUrl + basePath}scenic/lines`,
    // 获取多地图
    getMultiMap: `${baseUrl + basePath}scenic/panoramas`,
    // 获取vr地址
    getVr: `${baseUrl + v5}scenic_map/vr`,
    // // 平台分类
    allClassify: `${baseUrl + v5}scenic_map/classify_all`,
    // // 内容分类
    spots: `${baseUrl + v5}scenic_map/viewpoint_all`,
    // 获取范围
    scope: `${baseUrl + v5}scenic/scope`,
    // 根据景区获取是否有答题活动
    questionByScenic: `${baseUrl + v5}question/by_scenic`,
    // 答题错误
    questionWrong: `${baseUrl + v5}question/wrong`,
    // 答题正确
    questionReceiveBox: `${baseUrl + v5}question/receive_box`,
    // 答题活动
    question: `${baseUrl + v5}question/index`,
    // 答题榜
    questionRanking: `${baseUrl + v5}question/ranking`,
    // 我的奖品
    questionUserGifts: `${baseUrl + v5}question/user_gifts`,
	// 用户答题记录
	questionRecord: `${baseUrl + v5}question/record`,
    // 百度轨迹纠偏
    baiduTrack: `${baseUrl}h5s/apis/rectify/v1/track`,

    // 根据key值获取储存的数据
    getCache: `${baseUrl + scenicBasePath}common/get_cache`,

    // 定制模块
    customize: `${baseUrl + scenicBasePath}scenic/customize`,

    // 分享二维码
    posterShare: `${baseUrl + scenicBasePath}poster/share`,

	// 景点视频列表
	viewpointVideos: `${baseUrl + v5}viewpoint/videos`,
    // 景区首页公告
	scenicNotice: `${baseUrl + scenicBasePath}scenic/notice`,
    // 景区线路标签列表
	scenicLineLabels: `${baseUrl + v5}scenic/line_labels`,
    // 景区线路标签列表
	scenicMapAr: `${baseUrl + v5}scenic_map/ar`,




    // 获取海康播放地址
	otherHaikangCamera: `${baseUrl + scenicBasePath}other/haikang_camera`,
    scenicMould: `${ baseUrl + scenicBasePath }scenic/mould`,



    
    // 城市信息
    scenicInfo: `${ baseUrl }api/city/index`,
    // 城市平台分类
    allClassify: `${ baseUrl }api/city/classify`,
    // // 获取当前景区的全景图信息
    // panoramaInfo: `${ baseUrl }api/scenic/map`,
    // 城市获取多地图
    getMultiMap: `${ baseUrl }api/city/map`,
    // 城市线路规划
    scenicLines: `${ baseUrl }api/city/lines`,
    // 城市内容分类
    spots: `${ baseUrl }api/city/content`,
    // 景区信息
    scenicInfo1: `${ baseUrl }api/scenic/index`,
    // 景区平台分类
    allClassify1: `${ baseUrl }api/scenic/classify`,
    // // 获取当前景区的全景图信息
    // panoramaInfo1: `${ baseUrl }api/scenic/map`,
    // 景区获取多地图
    getMultiMap1: `${ baseUrl }api/scenic/map`,
    // 景区线路规划
    scenicLines1: `${ baseUrl }api/scenic/lines`,
    // 景区内容分类
    spots1: `${ baseUrl }api/scenic/content`,
    // 微信jssdk注册
    registerSDK: `${ baseUrl }api/map/jssdk`,
    // 景区列表
    scenicList: `${ baseUrl }api/scenic/list`,


    // 答题景点-列表
    questionPointList: `${ baseUrl }api/question_active/point_list`,
    // 答题题目
    questionQuestion: `${ baseUrl }api/question_active/question`,
    // 答题
    questionAnswer: `${ baseUrl }api/question_active/answer`,

    // 慢直播详情
	liveSlowDetail: `${baseUrl}api/live_slow/detail`,
    // 客流统计
	visitor: `${baseUrl}api/index/visitor`,
}
